import DecedentResidence from '@/common/containers/Forms/DecedentResidence/DecedentResidence';

export default DecedentResidence;
